import React from 'react';
import { Helmet } from 'react-helmet';
import { ROUTES } from '../../lib/constants';
import styles from './GigInternet.module.scss';
import { Button } from '../../components/Button/Button';
import { Solutions } from './Solutions/Solutions';
import { Packages } from './Packages/Packages';

export const GigInternet = (): React.JSX.Element => {
  
  return (
    <>
      <Helmet>
        <title>{ROUTES.gigInternet.title}</title>
      </Helmet>

      <div className='bg-color--marina-blue'>
        <div className='grid-12'>
          <section className={styles.hero}>
            <div>
              <h1 className='headline__h1 color--citron-yellow'>
                Upgrade your<br />
                internet experience
              </h1>

              <p className='subtitle color--white'>
                Choose the package below that&rsquo;s<br />
                built for your needs
              </p>

              <Button 
                path={ROUTES.checkAvailability.path}
                target='_self'
                size='lg' 
                className='bg-color--white color--marina-blue'
              >
                Sign Up Today
              </Button>
            </div>

            <div>
              <ul className='checkmark-list'>
                <li>Equipment included</li>
                <li>Installation included</li>
                <li>No service fees</li>
                <li>No data caps</li>
              </ul>
              <ul className='checkmark-list'>
                <li>No long term contracts</li>
                <li>No early exit fees</li>
                <li>No promo gimmicks</li>
                <li>No gimmicks at all, really!</li>
              </ul>
            </div>
            
          </section>

          <Packages />
          <Solutions />
        </div>
      </div>
    </>
  )
}